import React from "react";
import "./LoadingData.css";
import loadinglogo from "../src/img/loadinglogo.png";

function LoadingData() {
  return (
    <div className="LoadingData">
      <div className="LoadingData__logoblock">
        <div className="LoadingData__logoblock__img">
          <img src={loadinglogo} alt="Luxury villa with sea view in Costa Blanca, Spain" />
        </div>
        <div className="LoadingData__logoblock__block">
          <span class="loader"></span>
        </div>
      </div>


    </div>
  );
}

export default LoadingData;
